export default __webpack_public_path__ + "static/media/priestofmitraaction.47c42cf6.png";